import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actionSetOperatorOverlayOpen } from 'lib/actions';

// Registers a locally-managed operator overlay's open/closed state (keyed by a
// stable id) so the downtime watcher can suppress the prompt while it's on
// screen. The cleanup clears the flag if the host unmounts while still open —
// e.g. when a downtime flyup navigates away mid-flow.
const useRegisterOperatorOverlay = (id, isOpen) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionSetOperatorOverlayOpen(id, isOpen));
    return () => {
      dispatch(actionSetOperatorOverlayOpen(id, false));
    };
  }, [dispatch, id, isOpen]);
};

export { useRegisterOperatorOverlay };
